import script from "./PatientConsultationList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientConsultationList.vue?vue&type=script&lang=ts&setup=true"

import "./PatientConsultationList.vue?vue&type=style&index=0&id=06296301&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06296301"]])

export default __exports__